export default {
  Dispatcher: "Dispatcher",
  AddDispatcher: "AddDispatcher",
  editDispatcher: "EditDispatcher"
};
